  import { Pipe, PipeTransform } from '@angular/core';

  @Pipe({
    name: 'shortenString',
    pure: true
  })

  /*
  Example Usecase:
    1) For Default Font Size:
          { { job.name | shortenString : (nameCell.offsetWidth || 200) } }      --------- #nameCell is element refrence here
    2) For Custom Font Size:
          { { job.name | shortenString : (nameCell.offsetWidth || 200) : { fontSize: 16 } } }
  */
  export class ShortTheString implements PipeTransform {
    //Thisisjustatest
    private lastValue: string = '';
    private lastWidth: number = 0;
    private lastResult: string = '';
    private lastFontSize: number = 13;
    private lastStableWidth = 0;
    constructor() { }
    transform(
      value: string,
      maxWidth: number,
      config: {
        isSentence?: boolean,
        fontSize?: number,
        isPixelBased?: boolean,
        ellipsis?: string
      } = {}
    ): string {
      if (Math.abs(maxWidth - this.lastStableWidth) < 10) {
        return this.lastResult;
      }
      this.lastStableWidth = maxWidth;
      // Set default configuration
      const {
        isSentence = false,
        fontSize = 13,
        isPixelBased = true,
        ellipsis = '...'
      } = config;

      if(!value || !maxWidth || maxWidth <= 0) return value;
      // Check cache - return if nothing changed
      if (this.lastValue === value &&
        this.lastWidth === maxWidth &&
        this.lastFontSize === fontSize) {
        return this.lastResult;
      }
      // Calculate max characters based on input type
      let maxChars = maxWidth;
      if (isPixelBased) {
        const avgCharWidth = fontSize * 0.6;  
        maxChars = Math.max(3, Math.floor(maxWidth / avgCharWidth));
      }
      let result: string;
      if (isSentence) {
        result = this.truncateSentence(value, maxChars, ellipsis);
      } else {
        result = value.length <= maxChars
          ? value
          : value.substring(0, maxChars) + ellipsis;
      }
      // Update cache
      this.lastValue = value;
      this.lastWidth = maxWidth;
      this.lastFontSize = fontSize;
      this.lastResult = result;
      return result;
    }
    private truncateSentence(value: string, maxChars: number, ellipsis: string): string {
      return value.split(' ')
        .map(word => word.length > maxChars
          ? word.substring(0, maxChars) + ellipsis
          : word)
        .join(' ');
    }
  }
